import { EMPTY_OBJECT } from 'commons-ui';
import { URL, REFERRAL_RESOURCES } from '../../utils/helper';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'addUserInSegment':
			return () => {
				history.push({
					pathname: `${URL[REFERRAL_RESOURCES.referralSegment]}/updateUserReferralSegment`,
					state: {
						rowData
					}
				});
			};
		default:
			return EMPTY_OBJECT;
	}
};

export default {
	makeActionHandler
};
